export default class RecurrenceTypes {
    static RECURRENCE_TYPE_CURRENT_SEMESTER = 0;
    static RECURRENCE_TYPE_CURRENT_NO_CLASSES = 2;
    static RECURRENCE_TYPE_NEXT_SEMESTER = 3;
    static RECURRENCE_TYPE_NEXT_NO_CLASSES = 4;
    static RECURRENCE_TYPE_FROM_UNTIL = 1;
}